<div class="row w-100 no-gutters" *ngIf="patientDetails && !isReferral">
    <!-- <div class="col-md-9 row no-gutters"> -->
    <dt class="col-sm-12 mb-3 text-default text-center">Patient Details</dt>
    <dt class="col-sm-5">Patient Status</dt>
    <dd class="col-sm-7">
        <span
            *ngIf="patientDetails.PatientStatus == 'New' && patientDetails.IsArchived===0 && patientDetails.IsContacted===0"
            class="badge badge-primary p-2">New</span>
        <span
            *ngIf="patientDetails.PatientStatus == 'New' && patientDetails.IsArchived===0 && patientDetails.IsContacted===1"
            class="badge badge-warning p-2">Contacted</span>
        <span *ngIf="patientDetails.PatientStatus == 'Existing' && patientDetails.IsArchived===0"
            class="badge badge-success p-2">{{patientDetails.PatientStatus}}</span>
        <span *ngIf="patientDetails.IsArchived == 1" class="badge badge-danger p-2">Archived</span>
    </dd>
    <dt class="col-sm-5">Patient Title</dt>
    <dd class="col-sm-7">
        <span *ngIf="!editPatientTitle && patientDetails.Title" class="mr-3">{{patientDetails.Title}}</span>
        <span *ngIf="!editPatientTitle && patientDetails.IsArchived == 0">
            <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Title" matTooltipPosition="right"
                (click)="editPatientsTitle(patientDetails.PatientID)"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientTitle">
            <select type="text" class="form-control" placeholder="Title" id="title" [(ngModel)]="patientTitle"
                [ngClass]="{'red-border-class':editPatientTitle && !patientTitle}">
                <option value="" selected disabled>Title</option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Ms">Ms</option>
            </select>
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientTitle(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientTitle()" matTooltip="Cancel"></i>
            </span>
        </div>
    </dd>
    <dt class="col-sm-5">Patient Name</dt>
    <dd class="col-sm-7 row mx-0">
        <a (click)="showPatientDetails()">
            <span>{{patientDetails.FirstName}}
                {{patientDetails.LastName}}</span>
        </a>
        <div data-tip="Family Head">
            <img src="assets/images/father.svg" width="25" height="25" class="ml-3"
                *ngIf="patientDetails.IsFamilyHead===1">
        </div>
        <div data-tip="Financial Head">
            <img src="assets/images/pounds-sticker.svg" width="25" height="25" class="ml-3 active"
                *ngIf="patientDetails.IsFinancialHead===1">
        </div>
    </dd>
    <dt id="PatientCode" class="col-sm-5">Patient Code</dt>
    <dd class="col-sm-7" id="ddPatientCode">
        <span  *ngIf="!editPatientNumber && patientDetails.PatientCode"
            class="mr-3 badge badge-primary">{{patientDetails.PatientCode}}</span>
        <span *ngIf="!editPatientNumber && patientDetails.IsArchived == 0">
            <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Code" matTooltipPosition="right"
                (click)="editPatientReferenceNumber(patientDetails.PatientID)"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientNumber">
            <input type="text" id="patientRefNumber" value="" placeholder="Patient Code"
                class="form-control form-control-sm" [(ngModel)]="patientRefNumber"
                (keyup)="isValidPatientRefNUmber($event)" maxlength="20"
                [ngClass]="{'red-border-class':editPatientReferenceNumber && !patientRefNumber}" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientReferenceNumber(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientReferenceNumber()" matTooltip="Cancel"></i>
            </span>           
        </div>
        <div >
             <span *ngIf="isInvalidPatientCode" class="text-warning">No special characters allowed</span>
             <span *ngIf="isDuplicatePatientCode" class="text-danger" >Patient Code already exists</span>
        </div>
    </dd>
    <dt class="col-sm-5" *ngIf="patientDetails.PatientRegNumber">Old Reference #</dt>
    <dd class="col-sm-7" *ngIf="patientDetails.PatientRegNumber">
        <span *ngIf="patientDetails.PatientRegNumber"
            class="mr-3 badge badge-secondary">{{patientDetails.PatientRegNumber}}</span>
    </dd>
    <dt class="col-sm-5">DOB</dt>
    <dd class="col-sm-7">
        <span *ngIf="!editPatientDOB && patientDetails.DOB" class="mr-3">{{patientDetails.DOB}}</span>
        <span *ngIf="!editPatientDOB && patientDetails.IsArchived == 0">
            <i class="fa fa-edit cursor text-info" matTooltip="Edit Patient DOB" matTooltipPosition="right"
                (click)="editPatientsDOB(patientDetails.PatientID)"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientDOB">
            <input type="date" id="patientDOB" value="" [(ngModel)]="patientDOB"
                class="form-control form-control-sm col-md-8" placeholder="Patient DOB"
                [ngClass]="{'red-border-class':editPatientDOB&& !patientDOB}" />
            <span class="col-md-4 row px-0 no-gutters">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientDOB(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientDOB()" matTooltip="Cancel"></i>
            </span>
        </div>
    </dd>
    <dt class="col-sm-5">Email</dt>
    <dd class="col-sm-7">
        <span *ngIf="!editPatientEmail && patientDetails.Email" class="mr-3">{{patientDetails.Email}}</span>
        <span *ngIf="!editPatientEmail && patientDetails.IsArchived == 0">
            <i class="fa fa-edit cursor text-info" matTooltip="Edit Patient Email" matTooltipPosition="right"
                (click)="editPatientsEmail(patientDetails.PatientID)"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientEmail">
            <input type="text" id="patientEmail" value="" class="form-control form-control-sm"
                [(ngModel)]="patientEmail" placeholder="Patient Email" (keyup)="isValidPatientEmail($event)"
                [ngClass]="{'red-border-class':editPatientEmail && !patientEmail}" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientEmail(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientEmail()" matTooltip="Cancel"></i>
            </span>
        </div>
        <span *ngIf="isInvalidPatientEmail" class="text-warning">Email
            required format is john@example.com.</span>
    </dd>
    <dt class="col-sm-5">Phone Number</dt>
    <dd class="col-sm-7">
        <span *ngIf="!editPatientPhoneNumber && patientDetails.PhoneNumber "
            class="mr-3">{{patientDetails.PhoneNumber}}</span>
        <span *ngIf="!editPatientPhoneNumber && patientDetails.IsArchived == 0">
            <i class="fa fa-edit cursor text-info" matTooltip="Edit Patient Phone Number" matTooltipPosition="right"
                (click)="editPatientsPhoneNumber()"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientPhoneNumber">
            <input type="text" id="patientPhoneNumber" value="" class="form-control form-control-sm"
                [(ngModel)]="patientPhoneNumber" placeholder="Patient Phone Number" maxlength="12" minlength="7"
                [ngClass]="{'red-border-class':editPatientPhoneNumber && !patientPhoneNumber}"
                (keyup)="isValidPatientPhone($event)" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientPhoneNumber(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientPhoneNumber()" matTooltip="Cancel"></i>
            </span>
        </div>
        <span *ngIf="isInvalidPatientPhone" class="text-warning">Phone Number must contain digits only.</span>
    </dd>
    <dt class="col-sm-5">Landline Number</dt>
    <dd class="col-sm-7">
        <span *ngIf="!editPatientLandLineNumber && patientDetails.LandLineNumber"
            class="mr-3">{{patientDetails.LandLineNumber}}</span>
        <span *ngIf="!editPatientLandLineNumber && patientDetails.IsArchived == 0">
            <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Landline Number" matTooltipPosition="right"
                (click)="editPatientsLandLineNumber()"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientLandLineNumber">
            <input type="text" id="patientLandLineNumber" value="" maxlength="12" minlength="7"
                placeholder="Patient Landline Number" class="form-control form-control-sm"
                [ngClass]="{'red-border-class':editPatientLandLineNumber && !patientLandLineNumber}"
                [(ngModel)]="patientLandLineNumber" (keyup)="isValidPatientLandLine($event)" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendLandLineNumber(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientLandLineNumber()" matTooltip="Cancel"></i>
            </span>
        </div>
        <span *ngIf="isInvalidPatientLandline" class="text-warning font-sm">Landline Number must contain
            digits only.</span>
    </dd>
    <dt id="asgnDentist" class="col-sm-5">Assigned Dentist</dt>
    <dd class="col-sm-7">
        <span id="agnDentist" *ngIf="!editAssignedDentist && patientDetails.AssignedDentist" class="mr-3">{{patientDetails.AssignedDentist}}</span>
        <span *ngIf="!editAssignedDentist && patientDetails.IsArchived == 0">
            <i class="fa fa-edit text-info cursor" matTooltip="Edit Assigned Dentist" matTooltipPosition="right"
                (click)="editPatientAssignedDentist()"></i>
        </span>  
        <div class="d-flex align-items-center form-group" *ngIf="editAssignedDentist">
            <select type="text" class="form-control" placeholder="AssignedDentist" id="assignedDentist" [(ngModel)]="AssignedDentist"
                [ngClass]="{'red-border-class':AssignedDentist && !AssignedDentist}">
                <option value="" selected disabled>Select Dentist </option>
                <option value= {{item.StaffName}} *ngFor="let item of DentistList">
                    {{item.StaffName}}</option>
            </select>
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendAssignedDentist(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelAssignedDentist()" matTooltip="Cancel"></i>
            </span>
        </div>
    </dd>
</div>
<div *ngIf="patientDetails && isReferral">
    <h4 class="border-bottom mb-2 text-default mb-2">Patient Details</h4>
    <div class="">
        <span *ngIf="!editPatientNumber && patientDetails.PatientCode"
            class="mr-3 badge badge-primary">{{patientDetails.PatientCode}}</span>
        <span *ngIf="!editPatientNumber && patientDetails.IsArchived == 0">
            <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Code" matTooltipPosition="right"
                (click)="editPatientReferenceNumber(patientDetails.PatientID)"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientNumber">
            <input type="text" id="patientRefNumber" value="" placeholder="Patient Code"
                class="form-control form-control-sm" [(ngModel)]="patientRefNumber"
                (keyup)="isValidPatientRefNUmber($event)"
                [ngClass]="{'red-border-class':editPatientNumber && !patientRefNumber}" maxlength="20" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientReferenceNumber(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientReferenceNumber()" matTooltip="Cancel"></i>
            </span>
        </div>
        <!-- <span *ngIf="submitted && !patientRefNumber" class="text-danger">required</span> -->
        <span *ngIf="isInvalidPatientCode" class="text-warning">No special characters allowed</span>
    </div>
    <p *ngIf="patientDetails.PatientRegNumber">
        <span class="badge badge-secondary">{{patientDetails.PatientRegNumber}}</span>
    </p>
    <a (click)="viewPatient()" *ngIf="patientDetails.FullName">
        <p *ngIf="patientDetails.FullName">{{patientDetails.Title}} {{patientDetails.FullName}}</p>
    </a>
    <div class="">
        <span *ngIf="!editPatientDOB && patientDetails.DOB" class="mr-3">{{patientDetails.DOB}}</span>
        <span *ngIf="!editPatientDOB && patientDetails.IsArchived == 0">
            <i class="fa fa-edit cursor text-info" matTooltip="Edit Patient DOB" matTooltipPosition="right"
                (click)="editPatientsDOB(patientDetails.PatientID)"></i>
        </span>
        <div class="row mx-0 align-items-center form-group" *ngIf="editPatientDOB">
            <input type="date" id="patientDOB" value="" [(ngModel)]="patientDOB"
                class="form-control form-control-sm col-md-8" placeholder="Patient DOB"
                [ngClass]="{'red-border-class':editPatientDOB && !patientDOB}" />
            <span class="col-md-4 row px-0 no-gutters">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientDOB(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientDOB()" matTooltip="Cancel"></i>
            </span>
        </div>
    </div>

    <p>{{patientDetails.Gender}}</p>
    <div class="">
        <span *ngIf="!editPatientEmail && patientDetails.Email" class="mr-3">{{patientDetails.Email}}</span>
        <span *ngIf="!editPatientEmail && patientDetails.IsArchived == 0">
            <i class="fa fa-edit cursor text-info" matTooltip="Edit Patient Email" matTooltipPosition="right"
                (click)="editPatientsEmail(patientDetails.PatientID)"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientEmail">
            <input type="text" id="patientEmail" value="" class="form-control form-control-sm"
                [(ngModel)]="patientEmail" placeholder="Patient Email"
                [ngClass]="{'red-border-class':editPatientEmail && !patientEmail}"
                (keyup)="isValidPatientEmail($event)" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientEmail(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientEmail()" matTooltip="Cancel"></i>
            </span>
        </div>
        <span *ngIf="isInvalidPatientEmail" class="text-warning">Email
            required format is john@example.com.</span>
    </div>
    <div class="">
        <span *ngIf="!editPatientPhoneNumber && patientDetails.PhoneNumber "
            class="mr-3">{{patientDetails.PhoneNumber}}</span>
        <span *ngIf="!editPatientPhoneNumber && patientDetails.IsArchived == 0">
            <i class="fa fa-edit cursor text-info" matTooltip="Edit Patient Phone Number" matTooltipPosition="right"
                (click)="editPatientsPhoneNumber()"></i>
        </span>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientPhoneNumber">
            <input type="text" id="patientPhoneNumber" value="" class="form-control form-control-sm"
                [(ngModel)]="patientPhoneNumber" placeholder="Patient Phone Number"
                [ngClass]="{'red-border-class':editPatientPhoneNumber && !patientPhoneNumber}" maxlength="12"
                minlength="7" (keyup)="isValidPatientPhone($event)" />
            <span class="d-flex">
                <i class="fa fa-check-circle cursor text-success ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientPhoneNumber(patientDetails.PatientID)" matTooltip="Save"></i>
                <i class="fa fa-times-circle cursor text-danger ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientPhoneNumber()" matTooltip="Cancel"></i>
            </span>
        </div>
        <span *ngIf="isInvalidPatientPhone" class="text-warning">Phone Number must contain digits
            only.</span>
    </div>

</div>
<app-toast-message></app-toast-message>


<!-- <p>
            <span *ngIf="!editPatientPhoneNumber && patientDetails.PhoneNumber"
                class="mr-3">{{patientDetails.PhoneNumber}}</span>
            <span *ngIf="!editPatientPhoneNumber">
                <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Phone Number" matTooltipPosition="right"
                    (click)="editPatientsPhoneNumber()"></i>
            </span>
        </p>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientPhoneNumber">
            <input type="text" id="patientPhoneNumber" placeholder="Phone Number" value=""
                class="form-control form-control-sm" />
            <span class="d-flex">
                <i class="fa fa-check-circle text-success cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientPhoneNumber(patientDetails.PatientID)"></i>
                <i class="fa fa-times-circle text-danger cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientPhoneNumber()"></i>
            </span>
        </div> -->
<!-- <p>
            <span *ngIf="!editPatientEmail && patientDetails.Email"
                class="mr-3">{{patientDetails.Email}}</span>
            <span *ngIf="!editPatientEmail">
                <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Email" matTooltipPosition="right"
                    (click)="editPatientsEmail(patientDetails.PatientID)"></i>
            </span>
        </p>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientEmail">
            <input type="text" id="patientEmail" placeholder="Email" value="" class="form-control form-control-sm" />
            <span class="d-flex">
                <i class="fa fa-check-circle text-success cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientEmail(patientDetails.PatientID)"></i>
                <i class="fa fa-times-circle text-danger cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientEmail()"></i>
            </span>
        </div> -->
<!-- <p>
            <span *ngIf="!editPatientDOB && patientDetails.DOB" class="mr-3">{{patientDetails.DOB}}</span>
            <span *ngIf="!editPatientDOB">
                <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient DOB" matTooltipPosition="right"
                    (click)="editPatientsDOB(patientDetails.PatientID)"></i>
            </span>
        </p>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientDOB">
            <input type="date" id="patientDOB" placeholder="Date Of Birth" value=""
                class="form-control form-control-sm" />
            <span class="d-flex">
                <i class="fa fa-check-circle text-success cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientDOB(patientDetails.PatientID)"></i>
                <i class="fa fa-times-circle text-danger cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientDOB()"></i>
            </span>
        </div> -->
<!-- <p>
            <span *ngIf="!editPatientNumber && patientDetails.PatientCode"
                class="mr-3 badge badge-primary">{{patientDetails.PatientCode}}</span>
            <span *ngIf="!editPatientNumber">
                <i class="fa fa-edit text-info cursor" matTooltip="Edit Patient Code" matTooltipPosition="right"
                    (click)="editPatientReferenceNumber(patientDetails.PatientID)"></i>
            </span>
        </p>
        <div class="d-flex align-items-center form-group" *ngIf="editPatientNumber">
            <input type="text" id="patientRefNumber" placeholder="Patient Ref Number" value=""
                class="form-control form-control-sm" />
            <span class="d-flex">
                <i class="fa fa-check-circle text-success cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="sendPatientReferenceNumber(patientDetails.PatientID)"></i>
                <i class="fa fa-times-circle text-danger cursor ml-2 h5" style="font-size: 1rem;"
                    (click)="cancelPatientReferenceNumber()"></i>
            </span>
        </div> -->